import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import {
  trigger,
  state,
  transition,
  style,
  animate,
} from '@angular/animations';

@Component({
  selector: 'app-question',
  templateUrl: './question.component.html',
  styleUrls: ['./question.component.scss'],
  animations: [
    trigger('slide', [
      state('enter', style({ opacity: 0 })),
      state('in', style({ opacity: 1 })),
      state('leave', style({ opacity: 0 })),
      transition('enter => in', animate('250ms ease-out')),
      transition('in => leave', animate('250ms ease-in')),
      transition('leave => in', animate('250ms ease-out')),
      transition('in => enter', animate('250ms ease-in')),
    ]),
  ],
})
export class QuestionComponent implements OnInit {
  @Input() public question: any;
  @Output() public answered = new EventEmitter<any>();
  public answers = [];
  public animationState = 'in';
  public selectedDropdownItem = false;

  get selectedAnswer() {
    if (this.answers[this.question.id]) {
      return this.answers[this.question.id];
    } else {
      return false;
    }
  }

  constructor() {}

  ngOnInit(): void {}

  dropdownChanged(event): void {
    this.clickAnswer(event);
  }

  clickAnswer(answer: any): void {
    this.answers[this.question.id] = answer;
    this.animationState = 'leave';
    setTimeout(() => {
      this.answered.emit(this.answers);
      this.animationState = 'in';
    }, 350);
  }
}
